import { useCallback, useState } from "react";
import { useMutation } from "@tanstack/react-query";

import { submitFeedback } from "@app/services/feedback";

import { store } from "../store";

export const useSubmitFeedback = (options = {}) => {
  return useMutation({
    mutationFn: (feedback, { signal }) => submitFeedback(feedback, { signal }),
    onSuccess: () => {
      store
        .getState()
        .addToast("Thanks for your feedback!", {
          variant: "positive",
          timeout: 5000,
        });
    },
    meta: {
      errorMessage: "Failed to submit feedback. Please try again.",
    },
    ...options,
  });
};

/**
 * Manages the feedback dialog open state for the manual (header button)
 * trigger.
 */
export const useVideoFeedback = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return { isOpen, open, close, method: "manual" };
};
